import React, { useState, useEffect, useRef } from 'react';
import { useParams } from "react-router-dom";
import { connect, useSelector } from 'react-redux'
import CryptoJs from 'crypto-js';
import { Oval } from 'react-loader-spinner';
import { setLoading, setSnackInfo } from '../redux/actions/appAction';
import HttpService from '../services/httpService';
import { TextField, FormControl, Typography, DialogTitle, Dialog, DialogContent, DialogActions, Button, Paper, Divider, Box, DialogContentText } from '@material-ui/core';
import { ROLENAME, constantDepartmentId} from '../utils/index';
import DesignForm from '../pages/customerSurveyForm/design'
import {  DownloadOutlined } from '@ant-design/icons';
import moment from 'moment'
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import {IP} from "../utils/index"
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';


const CustomerContractSignView = (props) => {
    const { leadId } = useParams();
    const ref = useRef(null);
    useEffect(() => {
        getLeadDetails();
        // eslint-disable-next-line
    }, [leadId])

    const [leadDetail, setLeadDetails] = useState([]);
    const [loading, setLoading] = useState(false);
    const [btnDisable, setBtnDisable] = useState(false);
    const [leadOwnerDetail, setLeadOwnerDetail] = useState({
        name: '',
        email: '',
        mobile: '',
        leadId: ''
    })
    // Created State for reject button modal
    const [openRejectModel, setOpenRejectModal] = useState(false);
    const [rejectReason, setRejectReason] = useState("");
    const getLeadDetails = async () => {
        props.setLoading(true)
        try {
            const response = await HttpService.getLeadDetails(leadId);
            let leadOwnersList = [];
            for (let i = 0; i < response.data.previouslyAssignedTo.length; i++) {
                for (let j = 0; j < response.data.previouslyAssignedTo[i].roles.length; j++) {
                    if (response.data.departmentId === constantDepartmentId.design && response.data.previouslyAssignedTo[i]['roles'][j].name === ROLENAME.AssistanceDesignManager) {
                        leadOwnersList.push(response.data.previouslyAssignedTo[i])
                    } else if (response.data.departmentId === constantDepartmentId.design && response.data.previouslyAssignedTo[i]['roles'][j].name === ROLENAME.DesignManager) {
                        leadOwnersList.push(response.data.previouslyAssignedTo[i])
                    } else if (response.data.departmentId === constantDepartmentId.design && response.data.previouslyAssignedTo[i]['roles'][j].name === ROLENAME.DesignUser) {
                        leadOwnersList.push(response.data.previouslyAssignedTo[i])
                    }
                }
            }
            if (leadOwnersList.length !== 0) {
                let finalLeadOwnerUser = leadOwnersList.pop();
                setLeadOwnerDetail({
                    name: finalLeadOwnerUser.name,
                    email: finalLeadOwnerUser.email,
                    mobile: finalLeadOwnerUser.mobile,
                    _id: finalLeadOwnerUser._id,
                    customerId: response.data.customerId._id,
                    leadId: leadId
                })
            } else {
                setLeadOwnerDetail({
                    name: response.data.assignTo.name,
                    email: response.data.assignTo.email,
                    mobile: response.data.assignTo.mobile,
                    _id: response.data.assignTo._id,
                    customerId: response.data.customerId._id,
                    leadId: leadId
                })
            }
            setLeadDetails(response.data)
            setBtnDisable(response.data.contractCustomerApproved)
        } catch (error) {
            console.log(error, 'error')
            props.setSnackInfo(error?.response ?? "Something went wrong", "error")
        }
        props.setLoading(false)
    }

    const [openModal, setOpenModal] = useState(false);
    const { userDetails } = useSelector(state => state.user)

    const customerAction = async (status) => {
        if (status === 'Approve') {
            setOpenModal(true);
        } else {
            setOpenRejectModal(false);
            let obj = {
                contractCustomerApproved: false,
                status:'Reject',
                rejectMessage: rejectReason,
                userDetails: userDetails,
                rejectChecklistStatus: true
            }
            props.setLoading(true)
            try {
                await HttpService.customerContractSingActions(leadDetail._id, obj);
                getLeadDetails()
                props.setSnackInfo("Design Sign-off Rejected Successfully", "success")
            } catch (error) {
                console.log(error, 'error');
            }
            props.setLoading(false)
        }
    }

    const [otpSend, setOtpSend] = useState(false);
    const [otpResponse, setOtpResponse] = useState([]);
    const [email, setEmail] = useState('');
    const [mobile, setMobile] = useState('');
    const [contactPreference, setContactPreference] = useState("");

    const sendDataToParent = (formData) => {
        setDesignData(formData)
        setOTPMessage()
    };

    const setOTPMessage = async (e) => {
        // eslint-disable-next-line no-new-wrappers
    //    if (mobile.length === 10) {
        let obj = {};
        if (contactPreference === "email") {
            obj = {
                contactType: "email",
                email: email,
                whatsappNumber: null,
            };
        }
        if (contactPreference === "whatsapp") {
            obj = {
                contactType: "whatsapp",
                whatsappNumber: mobile.replace(/^(\+91|91)/, ""),
                email: null
            };
        }
        if (!contactPreference) {
            props.setSnackInfo("Please select OTP delivery method", "error");
            return;
        }
            setLoading(true)
            try {
                const response = await HttpService.sendOtpAccordingToContactTypeEmailOrMobile(obj)
                setOtpSend(true)

                // Decryption of OTP
                var bytes  = CryptoJs.AES.decrypt(response.data.otp, 'decorpot123');
                var decrypted_otpNumber = bytes.toString(CryptoJs.enc.Utf8);

                setOtpResponse({otp: Number(decrypted_otpNumber)})
                ref.current?.scrollIntoView({behavior: 'smooth'});
                let focusTextFieldOtp = document.getElementById('outlined-basic1-otp');
                focusTextFieldOtp.focus();
            } catch (error) {
                props.setSnackInfo(error.response.data.msg, "error")
            }
            setLoading(false)
            //}
    }

    const [otpVerified, setOtpVerified] = useState(false);
    const [designData, setDesignData] = useState({})
    const [disable, setDisable] = useState(false);
    const verifyOTP = (e) => {
        // eslint-disable-next-line no-new-wrappers
        let n = new String(e.target.value);
        if (n.length === 6 && otpResponse.otp === +e.target.value) {
            setOtpVerified(true);
        } else {
            setOtpVerified(false);
        }
    }

    const sendToImosAndSiteBOM = async () =>{
        props.setLoading(true)
        let obj = {
            ...designData
        };
        try {
            await HttpService.uploadAndSendToImosAndSiteBOM(leadDetail._id,obj);
            props.setSnackInfo("Project Created Successfully", "success")
            // history.push(`/lead-design-to-execution/${moment().subtract(1, 'months').format('YYYY-MM-DD')}/${moment().add(1, 'days').format('YYYY-MM-DD')}`);
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something went wrong", "error")
        }
        props.setLoading(false)
    }

    const uploadProductDocument = async () => {
        try {
            let divisionOfProject = ""
            if (leadDetail?.grandTotal < 1000000) {
                divisionOfProject = '<10L'
            } else if (leadDetail?.grandTotal > 2500000) {
                divisionOfProject = '25L+'
            } else {
                divisionOfProject = "10-25L"
            }
            let obj = {}

            obj.code = leadDetail.erpProjectNo
            obj.clientName = leadDetail.customerId.name
            obj.apartmentName = leadDetail.customerId.address
            obj.clientAddress = leadDetail.customerId.address
            obj.contactNumber = leadDetail.customerId.contact_no
            obj.status = "Site QC"
            obj.leadOwner = leadDetail.assignTo._id
            obj.locationId = leadDetail.city
            obj.experienceCenterId = leadDetail.experienceCenterId
            obj.departmentId = leadDetail.departmentId
            obj.teamId = leadDetail.teamId
            obj.leadId = leadDetail._id
            obj.stage = leadDetail.currentStage
            obj.contractCustomerApproved = leadDetail.contractCustomerApproved
            obj.financeStage = leadDetail.contractFinanceApproved
            obj.divisionOfProject = divisionOfProject
            obj.existingProject = false
            obj.documentFiles = [
                {
                    documentType: 'CheckList',
                    documentLink: leadDetail?.scanCheckListFile,
                    status: 'InSiteQC'
                },
                {
                    documentType: 'ContractSignaturePDF',
                    documentLink: leadDetail?.customerAgreementPdf || leadDetail?.termsAndConditionsPdf,
                    status: 'InSiteQC'
                },
  
              {
                    documentType: 'WorkingDrawingPDF',
                    documentLink: leadDetail?.workingDrawingFile,
                    status: 'InSiteQC'
                }
            ]

            const result = await HttpService.getProductDocAndCreateProject(obj)
            if (result.status === 200) {
                await sendToImosAndSiteBOM();
            }
        } catch (error) {
            console.log(error)
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
    }

    const verifyCustomer = async () => {
        setOpenModal(false);
        setDisable(true);
        
        let obj = {
            contractCustomerApproved: true,
            ...designData,
            leadOwner: leadOwnerDetail,
            typeOption: 'design'
        };

        try {
            setLoading(true);
    
            setOtpSend(false);
            setOtpResponse([]);
            await uploadProductDocument();
            await HttpService.customerContractSingActions(leadDetail._id, obj);
            await getLeadDetails();
            
            props.setSnackInfo("Design Sign-off Approved Successfully", "success");
        } catch (error) {
            console.error(error, 'error');
        } finally {
            setLoading(false);
        }
    };
    
    
    const  handleDownloadClick = (event, attachmentUrl)=> {
        window.open(attachmentUrl);
      }

    const designQuotationLink = async () => {
        try {
            props.setLoading(true);
            const fetchData = await HttpService.getVersionOfQuotationById(leadDetail?.designQuotationVersionId);
            const encoded = btoa(`${leadDetail._id}/${leadDetail?.version}`);
            window.open(`${IP.prodUrl}webQuotation/cx/${encoded}`)
            props.setLoading(false);
        } catch (error) {
            props.setLoading(false);
            console.log("error");
        }
    }  

    return (
        <div>
            <div style={{ marginBottom: 20, marginTop: 50 }}>
                <h2 style={{ textAlign: 'center' }}>Verify and Approve Design Sign-Off</h2>
                {loading && (
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100vh',
                    }}>
                        <Oval
                            height={80}
                            width={80}
                            color="#4fa94d"
                            visible={true}
                            ariaLabel="oval-loading"
                            secondaryColor="#4fa94d"
                            strokeWidth={2}
                            strokeWidthSecondary={2}
                        />
                    </div>
                )}
            </div>
            <Divider />

            {!loading &&<div style={{ margin: '50px auto', width: '80%', marginLeft: '100px' }}>
                <Paper>
                    <ul style={{ paddingTop: 20, marginLeft: '40px', }} >
                        <li><strong>Web Quotation:</strong> <Button color="primary" onClick={() => designQuotationLink()} style={{ textTransform: 'capitalize', textDecoration: 'underline' }}>Link</Button></li>
                        <li><strong>Quotation PDF:</strong> <Button color="primary" onClick={() => window.open(leadDetail?.scanQuotationFile)} style={{ textTransform: 'capitalize', textDecoration: 'underline' }}>View File</Button></li>

                        {/* <li><strong>Check List:</strong> <Button color="primary" onClick={() => window.open(leadDetail?.scanCheckListFile)} style={{ textTransform: 'capitalize', textDecoration: 'underline' }}>View File</Button></li> */}
                        <li><strong>Project Kick-Off Check List:</strong> <Button color="primary" onClick={() => window.open(leadDetail?.scanProjectKickOffCheckListFile)} style={{ textTransform: 'capitalize', textDecoration: 'underline' }}>View File</Button></li>
                        {leadDetail.currentStage === "Design Sign-off HOLD" && <li><strong>Design Sign-off HOLD Revoke Date: {leadDetail && moment(leadDetail?.designSignoffRevokeDate).format('D MMMM YYYY')}</strong> </li>}
                        <li><strong>Working Drawing:</strong> <Button color="primary" onClick={() => window.open(leadDetail?.workingDrawingFile)} style={{ textTransform: 'capitalize', textDecoration: 'underline' }}>View File</Button></li>
                        {/* <li><strong>Design Sign-off:</strong> <Button color="primary" onClick={() => window.open(leadDetail?.customerAgreementPdf)} style={{ textTransform: 'capitalize', textDecoration: 'underline' }}>View File</Button></li> */}
                        {leadDetail?.contractSignedPaymentReceviedAttachemnts ? (
                            <>
                                <li style={{ paddingTop: 10, paddingBottom: 8 }}>
                                    <strong>Payment Reciept: </strong>
                                    {leadDetail?.contractSignedPaymentReceviedAttachemnts.map((el, index) => (
                                        <span key={index}>
                                            <DownloadOutlined onClick={(e) => handleDownloadClick(e, el)} />
                                            {index < leadDetail.contractSignedPaymentReceviedAttachemnts.length - 1 ? ', ' : ''}
                                        </span>
                                    ))}
                                </li>
                            </>
                        ) : (
                            <li>
                                <strong>Payment Reciept: </strong>
                                <Button style={{ textTransform: 'capitalize' }}>Not Available</Button>
                            </li>
                        )}
                          {leadDetail?.siteQcVideo ? (
                            <>
                            <li style={{ paddingTop: 6, paddingBottom: 8 }}>
                            <strong>SiteQC Video: </strong> 
                            {leadDetail?.siteQcVideo?.map((el, index) => (
                                <span key={index}>
                                    <DownloadOutlined  onClick={(e) => handleDownloadClick(e,el)} />
                                {index < leadDetail.siteQcVideo?.length - 1 ? ', ' : ''}
                                </span>
                            ))}
                            </li>
                            </>
                            ) : (
                            <li>
                                <strong>SiteQC Video : </strong>
                                <Button style={{ textTransform: 'capitalize' }}>Not Available</Button>
                            </li>
                        )}

                        {leadDetail?.scanSiteQCPhotos ? (
                            <>
                                <li style={{ paddingTop: 6, paddingBottom: 8 }}>
                                    <strong>SiteQC Photos: </strong>
                                    {leadDetail?.scanSiteQCPhotos.map((el, index) => (
                                        <span key={index}>
                                            <DownloadOutlined onClick={(e) => handleDownloadClick(e, el)} />
                                            {index < leadDetail.scanSiteQCPhotos.length - 1 ? ', ' : ''}
                                        </span>
                                    ))}
                                </li>
                            </>
                        ) : (
                            <li>
                                <strong>SiteQC Photos: </strong>
                                <Button style={{ textTransform: 'capitalize' }}>Not Available</Button>
                            </li>
                        )}
                    </ul>

                    <div style={{ marginTop: 20, marginBottom: 20, marginLeft: 30, fontWeight: 700 }}> 
                        {btnDisable && `The Documents Have Been Verified and Digitally Signed, You'll Receive a Mail Shortly With The Details`}
                    </div>
                    <div style={{ marginTop: 20, marginBottom: 20 }}>
                        <Button onClick={()=>setOpenRejectModal(true)} disabled={btnDisable || leadDetail.contractDesignManagerApproved === false} variant="outlined" style={{ marginRight: 10, marginLeft: 30 }}>Reject</Button>
                        <Button onClick={() => customerAction("Approve")} disabled={btnDisable || leadDetail.contractDesignManagerApproved === false} variant="contained" color="primary">Proceed to Approval</Button>
                    </div>
                    <br />
                </Paper>
                <h3 style={{ marginTop: 20 }}>Note: After approval documents will be signed digitally</h3>
            </div>}

             <>
             <Dialog open={openModal} onClose={() => setOpenModal(false)} aria-labelledby="form-dialog-title" maxWidth='lg'>
                <DialogTitle id="form-dialog-title">Verify Details To Approve Design Sign-Off</DialogTitle>
                <Divider />
                <DialogContent>
                    <div >
                         <FormControl component="fieldset" style={{ marginTop: 20, marginBottom: 20 }}>
                                <FormLabel component="legend">How would you like to receive OTP? *</FormLabel>
                                <RadioGroup
                                    row
                                    value={contactPreference}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setContactPreference(value);

                                        //  clear other field
                                        if (value === "email") setMobile("");
                                        if (value === "whatsapp") setEmail("");
                                    }}
                                >
                                    <FormControlLabel value="email" control={<Radio />} label="Email" />
                                    <FormControlLabel value="whatsapp" control={<Radio />} label="WhatsApp" />
                                </RadioGroup>
                            </FormControl>

                            {contactPreference === "email" && (
                                <FormControl style={{ width: "100%", marginBottom: 20 }}>
                                    <TextField
                                        label="Enter Email ID *"
                                        variant="outlined"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                </FormControl>
                            )}

                            {contactPreference === "whatsapp" && (
                                <FormControl style={{ width: "100%", marginBottom: 20 }}>
                                    <TextField
                                        label="WhatsApp Number *"
                                        placeholder="10 digit mobile number"
                                        variant="outlined"
                                        value={mobile}
                                        inputProps={{
                                            maxLength: 10,
                                            inputMode: "numeric",
                                            pattern: "[0-9]*"
                                        }}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (/^\d{0,10}$/.test(value)) {
                                                setMobile(value);
                                            }
                                        }}
                                    />
                                </FormControl>
                            )}
                        <br />

                        <DesignForm
                            TYPEOPTION='design'
                            LEADOWNERDATA={leadOwnerDetail}
                            sendDataToParent={sendDataToParent}
                        />

                        {
                            otpSend === true && <Paper style={{ marginTop: 20, padding: 10 }} ref={ref}>
                                <Typography component="p" style={{ marginBottom: 10 }}> {contactPreference === "email"
                                        ? "Please check your email for OTP"
                                        : "Please check your WhatsApp for OTP"}</Typography>
                                <FormControl style={{ width: '30%', marginBottom: 20 }}>
                                    <TextField id="outlined-basic1-otp" label="Enter OTP" variant="outlined" name="otp" onChange={(e) => verifyOTP(e)} size="small" />
                                </FormControl>
                            </Paper>
                        }
                    </div>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button onClick={() => setOpenModal(false)} variant="outlined">No</Button>
                    <Button onClick={() => verifyCustomer()} variant="contained" color="primary" disabled={otpVerified === false || disable}>Verify</Button>
                </DialogActions>
            </Dialog>
            {loading && (
                    <Backdrop
                        open={true}
                        style={{
                            zIndex: 1400, // Higher than the Dialog's z-index
                            color: '#fff',
                        }}
                    >
                        <CircularProgress color="inherit" />
                    </Backdrop>
                )}
            </>

        {/* Creating Dialog Box: when Customer want to reject checklist and click reject button then open this dialog and ask for confirmation */}
            <Dialog
                open={openRejectModel}
                onClose={()=>setOpenRejectModal(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Reject Checklist"}</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="reject-reason"
                        label="Reason for rejection"
                        type="text"
                        style={{ width: '100%' }} 
                        value={rejectReason}
                        onChange={(e)=>setRejectReason(e.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => customerAction("Reject")} variant="contained" color="primary" >
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default connect(null, { setLoading, setSnackInfo })(CustomerContractSignView)
